import { TreasuryOfferBaseEntity } from '@genial/services';
import { TreasuryOrderBuyEntity } from '@genial/services/src';
import { Utils } from '@genial/utils';

import { notificationChannelsData } from '../../../../../../../Resume/utils';
import { TicketApplicationBaseInfoProps } from '../../components/TicketApplicationSuccessDetails';

export const getDirectTreasurySuccessInfos = (
  offer: TreasuryOfferBaseEntity,
  order: TreasuryOrderBuyEntity,
  showSendingChannels: boolean,
  hideDateTimeFieldsOnProverOrigin: boolean
): TicketApplicationBaseInfoProps => {
  const orderHash = order.orderHash || order.orderId || '--';
  const orderName = order.orderName;

  const orderNameFormatted = orderName && orderHash ? `${orderName} - ${orderHash}` : '--';

  const orderChannels = notificationChannelsData({ order });

  const hasOrderOrigin = !!order?.interactionChannelAuditDetail as boolean;

  const productDetails = [
    { label: 'Produto', value: offer.titleName },
    {
      label: 'Data da aplicação',
      value: Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy'),
    },
    {
      label: 'Data de liquidação',
      value: offer.settlementDate
        ? Utils.Mask.DateFormat(offer.settlementDate, 'dd/MM/yyyy')
        : '--',
    },
    {
      label: 'Vencimento',
      value: offer.maturityDate ? Utils.Mask.DateFormat(offer.maturityDate, 'dd/MM/yyyy') : '--',
    },
    { label: 'Quantidade', value: String(order.orderQuantity) },
    { label: 'Valor a aplicar', value: Utils.Mask.Money(order.orderAmount) },
  ];

  const solicitationDate = order.interactionChannelAuditDetail?.interactionChannelDate;

  const channelDetails = [
    {
      label: 'Canal de solicitação',
      value: order.interactionChannelAuditDetail?.interactionChannelOption.channel || '--',
    },
  ];

  if (!hideDateTimeFieldsOnProverOrigin) {
    channelDetails.push(
      {
        label: 'Data de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'dd/MM/yyyy') : '',
      },
      {
        label: 'Horário de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'HH:mm') : '',
      }
    );
  }

  const orderDetails = [
    { label: 'Nome da ordem', value: orderNameFormatted },
    ...(hasOrderOrigin ? channelDetails : []),
  ];

  if (showSendingChannels) {
    orderDetails.push(
      { label: 'Canal de envio', value: orderChannels || '--' },
      {
        label: 'Hora/data de Envio',
        value: order.orderCreatedAt
          ? Utils.Mask.DateFormat(order.orderCreatedAt, 'dd/MM/yyyy HH:mm:ss')
          : '--',
      }
    );
  }

  return {
    orderHash,
    productDetails,
    orderDetails,
  };
};
